module.exports = ({ transitions, variants }) => {
  return ({ e, addUtilities }) => {
    let utilities = Object.keys(transitions).map(key => ({
      [`.${e(`transition-${key}`)}`]: {
        transition: transitions[key]
      }
    }))

    addUtilities(utilities, variants)
  }
}
